import React from 'react';
import { Box } from '@chakra-ui/react';

function DashboardCard({ children, ...rest }) {
  return (
    <Box
      bg="white"
      borderColor="gray.300"
      borderRadius=".35rem"
      borderWidth={2}
      boxShadow="25px 25px 25px -30px rgba(0, 0, 0, 0.25)"
      flexDir="row"
      display={{ md: 'flex' }}
      justifyContent="left"
      minWidth={{ base: null, md: '60%', lg: '50%' }}
      padding={[6, 8]}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default DashboardCard;
